import getters from './getters';
import actions from './actions';
import mutations from './mutations';
export const state = () => ({
  newRelicScript: ''
});
export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};